<template>
	<div class="item-card">
		<div class="img-cont">
			<img :src="img"/>
		</div>
		<div class="item-cont-desc">
			<div class="item-cont-head">{{ head }}</div>
			<hr>
			<div class="item-cont-cont">{{ cont }}</div>
		</div>
	</div>
</template>

<script>
export default {
  props: ['head','cont'],
	data () {
    return {
			img: require('./assets/sh.png')
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-card{
	color: white;
	display: inline-flex;

	padding: 5px;
	font-size: 15px;
	
	height: 160px;
}
.item-cont-desc{
	width: 320px;
	
	border-left: 1px inset white;
	padding: 0px 5px;
	display: block;
}
.item-cont-head{
	font-size: 24px;
	text-transform: uppercase;
}
.item-cont-cont{
	font-size: 20px;
}
img{
	max-width: 80px;
}
@media screen and (min-width: 820px) and (max-width: 1220px){
  .item-cont-desc{
	width: 192px;
  }
  .item-cont-head{
	font-size: 18px;
	text-transform: uppercase;
  }
  .item-cont-cont{
	font-size: 14px;
  }
  img{
    max-width: 64px;
  }
}
@media screen and (min-width: 480px) and (max-width: 820px){
  .item-card{
		width: 100%;
    height: 80px;
  }
  .item-cont-desc{
		width: 100%;
  }
  .item-cont-head{
		font-size: 20px;
  }
  .item-cont-cont{
		font-size: 16px;
  }
  img{
    max-width: 64px;
  }
}
@media screen and (max-width: 480px){
  .item-card{
		text-align: justify;
		width: 100%;
		height: 80px;
		flex: 1;
  }
  .item-cont-desc{
    border-left: unset;
		width: 100%;
  }
  .item-cont-head{
		font-size: 18px;
  }
  .item-cont-cont{
		font-size: 14px;
  }

  img{
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ItemCard.vue